import React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/shared/Buttons/ActionButton';
import { getMonteCarloConfidenceScores } from 'services/Rest';
import { getCustomerHouseholdId } from 'state/customer/CustomerSelectors';

const onClick = (householdId = '') => {
  const body = {
    useRSP: true,
    imageheight: 150,
    imagewidth: 204,
    refreshposition: true,
    minwidth: 150,
    householdID: householdId
  };
  getMonteCarloConfidenceScores(body, 'current');
};

const ConfidenceRequestButton = ({ householdId }) => {
  return (
    <ActionButton
      id="confidence-request-button"
      onClick={() => onClick(householdId)}
      className="confidence-request-button"
    >
      Check Your Status
    </ActionButton>
  );
};

const mapStateToProps = (state) => ({
  householdId: getCustomerHouseholdId(state)
});

export default connect(mapStateToProps)(ConfidenceRequestButton);
